import React from "react";
import { Router, browserHistory, createRoutes } from "react-router";
import { useLDClient, useFlags } from "launchdarkly-react-client-sdk";
import { Provider } from "react-redux";
// @ts-ignore
import { syncHistoryWithStore } from "react-router-redux";
import { DndProvider } from "react-dnd-latest";

import { getStore } from "store";
import Backend from "lib/dnd-backend";
import rawRoutes from "./routes";
import me from "models/me";

const BindUser: React.FC<{}> = ({ children }) => {
    const client = useLDClient();
    me.bindLDClient(client);
    return <>{children}</>;
};

const Content = () => {
    const flags = useFlags();
    const store = getStore();
    /*
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./reducers', () => {
            const nextRootReducer = require('./reducers');
            store.replaceReducer(nextRootReducer);
        });
    }
    */
    const history = syncHistoryWithStore(browserHistory, store);
    /*
    function mixStoreToRoutes(routes) {
        return routes && routes.map(route => ({
            ...route,
            childRoutes: mixStoreToRoutes(route.childRoutes),
            onEnter: route.onEnter && function (props, replaceState, cb) {
                route.onEnter(props, replaceState, cb, store);
            }
        }));
    }
    */
    const routes = createRoutes(rawRoutes(flags)); //mixStoreToRoutes(createRoutes(rawRoutes));
    return (
        <BindUser>
            <Provider store={store}>
                <DndProvider backend={Backend}>
                    <Router history={history} routes={routes} />
                </DndProvider>
            </Provider>
        </BindUser>
    );
};

const appRouter = (LDProvider) =>
    LDProvider ? (
        <LDProvider>
            <Content />
        </LDProvider>
    ) : (
        <Content />
    );

export default appRouter;
